import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";
import { Box, Skeleton } from "@mui/material";
import BranchInfoWindow from "../ui/BranchInfoWindow";

const Map = ({ branches }) => {
  const [mapInstance, setMapInstance] = useState(null); // state variable for map instance
  const [zoom, setZoom] = useState(6);

  const [selectedMarker, setSelectedMarker] = useState(null);

  const { isLoaded } = useLoadScript({
    // googleMapsApiKey: "AIzaSyCUm5QEr8JDqyKEifqRoE3I1Z2rv7e0QNs",
    googleMapsApiKey: window.wcd_object.googleMapsApiKey,
  });
  const center = useMemo(
    () => ({ lat: 38.12333212008898, lng: -110.49761519422752 }),
    []
  );

  const onMapLoad = React.useCallback(function callback(map) {
    // // This is just an example of getting and using the map instance!!! don't just blindly copy!
    // const bounds = new window.google.maps.LatLngBounds(center);
    // map.fitBounds(bounds);

    setMapInstance(map);
  }, []);

  const onZoomChanged = useCallback(() => {
    // callback function to get zoom level
    if (mapInstance) {
      setZoom(mapInstance.getZoom());
    }
  }, [mapInstance]);

  useEffect(() => {
    // effect function to pan and zoom the map based on locations
    if (mapInstance && branches.length > 0) {
      // if map instance and locations are available
      const bounds = new window.google.maps.LatLngBounds(); // create a new bounds object
      branches.forEach((branch) => {
        // loop through each location
        const lat = branch.position.lat; // get latitude
        const lng = branch.position.lng; // get longitude
        bounds.extend({ lat, lng }); // extend the bounds to include this location
      });
      mapInstance.fitBounds(bounds); // fit the map to the bounds
      mapInstance.panToBounds(bounds); // pan the map to the bounds
    }
  }, [mapInstance, branches]);

  return (
    <Box
      sx={{ height: { xs: "30vh", sm: "75vh", md: "73vh" }, width: "100%" }}
      id="map-root"
    >
      {!isLoaded ? (
        <Skeleton
          sx={{ borderRadius: "25px" }}
          variant="rounded"
          width={388}
          height={988}
        />
      ) : (
        <GoogleMap
          mapContainerClassName="map-container"
          center={center}
          zoom={zoom}
          onLoad={onMapLoad}
          onZoomChanged={onZoomChanged}
          // onTilesLoaded={fitBounds}
          // ref={mapRef}
        >
          {branches.map((branch, index) => (
            <Marker
              key={index}
              position={branch.position}
              onClick={() => {
                setSelectedMarker(branch);
              }}
            />
          ))}
          {selectedMarker && (
            <InfoWindow
              position={selectedMarker.position}
              onCloseClick={() => {
                setSelectedMarker(null);
              }}
            >
              <BranchInfoWindow info={selectedMarker} />
            </InfoWindow>
          )}
        </GoogleMap>
      )}
    </Box>
  );
};

export default Map;
